// Copyright (C) 2016-2018 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd

export {AceEditorDirective,AceEditorModule} from './lib/ng-ace.module';